import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import { showPopupInfoTPRL, hidePopupInfoTPRL, updateParamSearchHisTPRLPopup } from "../redux/actions/sharedActions";
import Draggable, { } from "react-draggable";
import _ from "lodash";
import { formatNumber, formatQtty, formatQttyFull_emptyIsZezo, formataDate_DDMMYYYY } from "../helpers/utils";
import { Form as FormLayout, Button, Form, Input, InputNumber, DatePicker } from "antd";
import clsx from "clsx";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import AutoSizer from "react-virtualized-auto-sizer";
import Downshift from "downshift";
import ResizeObserver from "react-resize-observer";
import { DateFormat, useGlobalConst } from "../helpers/constData";
import { useApiStock } from "../helpers/apiStockHelper";
import Moment from "moment";
export default function PopupInfoDetailTPRL() {
  const refPopupContainer = useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const popupTRPLConfig = useSelector((state) => state.gShared.popupTPRLConfig);
  const stockInfo = useSelector((state) => state.gSymbol.symbolInfos.find((item) => item.code === popupTRPLConfig.code)) ?? {};

  const paramSearchHisStoredTPRL = useSelector((state) => state.gShared.paramSearchHisTPRLPopupDetail);

  const [chartType, setChartType] = useState("D");

  const [position, setPosition] = useState({ x: null, y: null });
  //
  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition({ x, y });
  };

  //detail
  const globalConst = useGlobalConst();
  const [formSearch] = Form.useForm();
  const stockAPI = useApiStock();
  const EMPTY_VALUE = "---";
  const [matchPriceColor, setMatchPriceColor] = useState("");
  const [maxPriceColor, setMaxPriceColor] = useState("");
  const [minPriceColor, setMinPriceColor] = useState("");
  const paramSearchHisStored = useSelector((state) => state.gShared.paramSearchHisTPRLPopupDetail);
  const [popUpTPRLPos, setPopUpTPRLPos] = useState(null);

  const ListBondFeature = {
    First: ["", t("lblTPThuong"), t("lblTPXanh")],
    Second: [t("lblKhongChuyenDoi"), t("lblTPChuyenDoi")],
    Third: [t("lblTPKhongKemCW"), t("lblTPKemCW")],
    Four: [t("lblTPKhongCoDamBao"), t("lblTPCoDamBao")],
  };

  var lstInterestrateType = ["", t("lblCodinh"), t("lblThaNoi"), t("lblKetHop")];
  var lstInterestPaymentType = ["", t("lblDinhKyCuoiKy"), t("lblDinhKyDauKy"), t("lblMotLanKhiDenHan"), t("lblKhac")];

  const [stockDetails, setStockDetails] = useState({
    stockInfo: {},
  });
  const [stockHists, setStockHists] = useState({
    stockHis: [],
  });
  

  //combobox search
  const refElementCalcSearchResult = useRef();
  const refElementPopup = useRef();

  const { initTime: gSymbolInitTime, symbolTPRLInfos: storedSymbolTPRL } = useSelector(
    (state) => ({
      initTime: state.gSymbol.initTime,
      symbolTPRLInfos: state.gSymbol.symbolTPRLInfos,
    }),
    (prev, next) => {
      return prev.initTime === next.initTime && prev.symbolTPRLInfos?.length === next.symbolTPRLInfos?.length;
    }
  );

  useEffect(async () => {
    try {
      setupDefaultValue();
      searchStockDetail();
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    _calcSearchResultPosition();
  }, [popUpTPRLPos, refElementCalcSearchResult])

  const _calcSearchResultPosition = () => {
    const el = document.getElementById("suggestion-results--tprl");
    if (refElementCalcSearchResult.current && el && popUpTPRLPos) {
      const rect = refElementCalcSearchResult.current._node.getBoundingClientRect();
      el.style.left = rect.x - popUpTPRLPos.x + "px";
      el.style.top = rect.y - popUpTPRLPos.y + rect.height + "px";
    } else {
      setTimeout(() => {
        _calcSearchResultPosition();
      }, 500);
    }
  };

  useEffect(() => {
    setupDefaultValue();
  }, [popupTRPLConfig.show]);

  const setupDefaultValue = () => {
    try {
      formSearch.setFieldValue("TradingDateFrom", Moment());
      formSearch.setFieldValue("TradingDateTo", Moment());
    } catch (error) {
      console.error(error);
    }
  };

  //lấy màu
  useEffect(() => {
    let _matchPriceColor = "#fff";
    let _maxPriceColor = "#fff";
    let _minPriceColor = "#fff";

    const matchPrice = stockDetails.stockInfo?.pt_MatchPrice ?? 0;
    const maxPrice = stockDetails.stockInfo?.pt_MaxPrice ?? 0;
    const minPrice = stockDetails.stockInfo?.pt_MinPrice ?? 0;
    const parvalue = stockDetails.stockInfo?.parvalue ?? 0;
  
    if (matchPrice > parvalue) {
      _matchPriceColor = "clr-up";
    } else if (matchPrice < parvalue) {
      _matchPriceColor = "clr-down";
    } else {
      _matchPriceColor = "clr-ref";
    }

    if (maxPrice > parvalue) {
      _maxPriceColor = "clr-up";
    } else if (maxPrice < parvalue) {
      _maxPriceColor = "clr-down";
    } else {
      _maxPriceColor = "clr-ref";
    }

    if (minPrice > parvalue) {
      _minPriceColor = "clr-up";
    } else if (minPrice < parvalue) {
      _minPriceColor = "clr-down";
    } else {
      _minPriceColor = "clr-ref";
    }

    setMatchPriceColor(_matchPriceColor);
    setMaxPriceColor(_maxPriceColor);
    setMinPriceColor(_minPriceColor);
  }, [stockDetails.stockInfo]);

  const getStockDetail = async (jsonData) => {
    try {
      await stockAPI
        .getDetailStockTPRL(jsonData)
        .then((res) => {
          if (res.status === 200) {
            if (res?.data?.stockBondInfo) {
              setStockDetails({
                stockHis: res?.data?.stockBondHist ?? [],
                stockInfo: res?.data?.stockBondInfo ?? {},
              });
            }
          }
        })
        .catch((err) => {
          console.log("err => ", err);
        })
        .finally(() => { });
    } catch (error) {
      console.log("ERROR => " + error);
    }
  };

  const getStockHist = async (jsonData) => {
    try {
      await stockAPI
        .getHistStockTPRL(jsonData)
        .then((res) => {
          if (res.status === 200) {
            if (res?.data?.stockBondHist) {
              setStockHists({
                stockHis: res?.data?.stockBondHist ?? [],
              });
            }
          }
        })
        .catch((err) => {
          console.log("err => ", err);
        })
        .finally(() => { });
    } catch (error) {
      console.log("ERROR => " + error);
    }
  };

  const searchStockDetail = async (isSearchAction = false) => {
    try {
      const values = formSearch.getFieldsValue();
      let _fromDateYYYY = values?.TradingDateFrom?.format(DateFormat.YYYYMMDD);
      let _toDateYYYY = values?.TradingDateTo?.format(DateFormat.YYYYMMDD);
      let _code = paramSearchHisStored.code;

      if (isSearchAction) {
        updateParamSearchHisTPRLPopup(dispatch, {
          code: paramSearchHisStored.code,
          tradingDateFrom: _fromDateYYYY,
          tradingDateTo: _toDateYYYY,
        });
      } else {
        _fromDateYYYY = paramSearchHisStored.tradingDateFrom;
        _toDateYYYY = paramSearchHisStored.tradingDateTo;
        _code = paramSearchHisStored.code;
      }

      // console.log(_code, "_code", _fromDateYYYY, "_fromDateYYYY", _toDateYYYY, "_toDateYYYY", "value search");
      if (!_fromDateYYYY && !_toDateYYYY) {
        setStockDetails({
          ...stockDetails,
          stockHis: [],
        });
      } else {
        await getStockDetail({ pSymbol: _code });
        await getStockHist({  pSymbol: _code, pFromDate: _fromDateYYYY, pToDate: _toDateYYYY });
      }
    } catch (error) {
      console.log("ERROR => " + error);
    }
  };

  useEffect(() => {
    //search ngay khi có thay đổi
    searchStockDetail();

    //mỗi 5 giây search lại 1 lần
    const interval = setInterval(() => {
      searchStockDetail();
    }, 5000);

    return () => clearInterval(interval);
  }, [paramSearchHisStored]);


  useEffect(() => {
    _calcSearchResultPosition();
  }, []);


  // highlight vào đầu danh sách suggest
  useEffect(() => {
    const el = document.getElementById("suggestion-results");

    if (el && el.firstElementChild) {
      el.firstElementChild.setAttribute("class", "highlighted");
      el.firstElementChild.setAttribute("aria-selected", true);
    }
  }, [paramSearchHisStored.code]);

  const _handleSearchValueChange = (value) => {
    if (value && value !== "") {
      value = value.toUpperCase();

      // tạm mở cho tìm đủ các mã
      const _symbolInfo = storedSymbolTPRL.find((e) => e.code === value);
      const _securityType = _symbolInfo?.securityType;
      const _marketCode = _symbolInfo?.marketCode;

      updateParamSearchHisTPRLPopup(dispatch, {
        code: value,
        tradingDateFrom: paramSearchHisStored.tradingDateFrom,
        tradingDateTo: paramSearchHisStored.tradingDateTo,
      });
      // setSearchValue("");
    }
  };

  const _handleSearchKeyDown = (event) => {
    if (event.defaultPrevented === false && event.keyCode === 13) {
      _handleSearchValueChange(event.target.value);
    }
  };
  //end detail


  const _onMessageReceived = (message) => {
    const _msgsource = message.data["source"];
    if (_msgsource === "tradingviewembedded") {
      const type = message.data.payload.type === "Index" ? "IDX" : message.data.payload.type === "Stock" ? "ST" : "";

      // if (type && type !== "") {
      //   showPopupInfoTPRL(dispatch, type, message.data.payload.symbol);
      // }
    }
  };

  const _handleClickOutsidePopup = (event) => {
    if (refPopupContainer && refPopupContainer.current === event.target) {
      handleClosePopup();
    }
  };
  const handleClosePopup = () => {
    hidePopupInfoTPRL(dispatch);
    setPosition({ x: null, y: null });
  };
  //
  useEffect(() => {
    window.addEventListener("message", _onMessageReceived, false);
    return () => {
      window.removeEventListener("message", _onMessageReceived, false);
    };
  }, []);

  useEffect(() => {
    if (!popupTRPLConfig.show && chartType !== "D") {
      setChartType("D");
    }
  });
  useEffect(() => {
    // Set giá trị mặc định ngay khi component mount
    document.documentElement.style.setProperty("--scrollbar-width", "0px");
  }, []);

  useLayoutEffect(() => {
    const tbody = document.querySelector(".table-scroll tbody");
    if (!tbody) return;

    const hasScrollbar = tbody.scrollHeight > tbody.clientHeight;
    const scrollbarWidth = hasScrollbar ? (tbody.offsetWidth - tbody.clientWidth) : 0;

    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  }, [stockHists]);

  return popupTRPLConfig.show ? (
    <div ref={refPopupContainer} className="popup-container" onClick={_handleClickOutsidePopup}>
      <ResizeObserver onResize={(rect) => { setPopUpTPRLPos(rect); }} onPosition={(rect) => { setPopUpTPRLPos(rect); }} onReflow={(rect) => { setPopUpTPRLPos(rect); }} />

      <Draggable onDrag={handleDrag} position={position}>
        <div className="popup">
          <div
            className="popup__header"
            onClick={() => {
              isMobile && handleClosePopup();
            }}
            style={{ marginTop: 10 }}
          >
            {popupTRPLConfig.type === "POPUP_TPRL" && (
              <>
                <div className="text-center" style={{ flex: 1 }}>
                  {paramSearchHisStoredTPRL ? `${t("thongTinTraiPhieu")} ${paramSearchHisStoredTPRL.code}` : ""}
                </div>
                <div className="popup__header--right">
                  <button
                    type="button"
                    onClick={() => {
                      handleClosePopup();
                    }}
                  >
                    <img src="/static/img/icon/icon-close.svg" alt="img" />
                  </button>
                </div>
              </>
            )}
          </div>
          <div className="body__modal popup__background-color">
            <div className="popup__content popup__body" style={{ overflowY: "unset !important" }}>
              {popupTRPLConfig.type === "POPUP_TPRL" ? (
                <div className="popup-bond">
                  <div className="boxsearch-stockcode-bond">
                    <ResizeObserver ref={refElementCalcSearchResult} onResize={_calcSearchResultPosition} onPosition={_calcSearchResultPosition} onReflow={_calcSearchResultPosition} />
                    <Downshift
                      onChange={(selection, agrs) => {
                        _handleSearchValueChange(selection ? selection.value : "");
                      }}
                      itemToString={(item) => {
                        return item ? item.value : "";
                      }}
                      onInputValueChange={(value) => {
                        updateParamSearchHisTPRLPopup(dispatch, { code: value });
                      }}
                      inputValue={paramSearchHisStored.code}
                      onOuterClick={() => {
                        // setSearchValue("");
                      }}>
                      {({ getInputProps, getItemProps, getLabelProps, getMenuProps, isOpen, inputValue, highlightedIndex, selectedItem }) => {
                        let results = [];
                        if (inputValue && inputValue !== "") {
                          results = storedSymbolTPRL
                            .filter(
                              (item) => item.code.includes(inputValue.toUpperCase())
                              // tạm mở cho tìm đủ các mã
                              // item.code.includes(inputValue.toUpperCase()) && symbolInfos.map(v=> v.code).includes(item?.code)
                            )
                            .sort((a, b) => a.code.indexOf(inputValue.toUpperCase()) - b.code.indexOf(inputValue.toUpperCase()) || a.code.localeCompare(b.code))
                            .map((item) => {
                              return {
                                value: item.code,
                                content: item.symbolName,
                                marketName: item.marketName,
                                matchIndex: item.code.indexOf(inputValue.toUpperCase()),
                              };
                            });
                        }
                        return (
                          <div className="position-relative">
                            <input
                              value={paramSearchHisStored.code}
                              {...getInputProps({
                                onKeyDown: (e) => {
                                  if (e.key === "Enter" && highlightedIndex === null) {
                                    _handleSearchKeyDown(e);
                                  }
                                },
                              })}
                            />
                            <span className="position-absolute hook">
                              <i className="fas fa-search"></i>
                            </span>
                            <ul {...getMenuProps()} id={"suggestion-results--tprl"} className="suggestion-results" style={{ display: isOpen ? "" : "none" }}>
                              {isOpen
                                ? results.map((item, index) => (
                                  <li
                                    key={index}
                                    {...getItemProps({
                                      key: item.value,
                                      index,
                                      item,
                                    })}
                                    className={highlightedIndex === index ? "highlighted" : ""}>
                                    <p>
                                      {item.value.substr(0, item.matchIndex)}f
                                      <span className="suggestion-text">{item.value.substr(item.matchIndex, inputValue.length)}</span>
                                      {item.value.substr(item.matchIndex + inputValue.length)} - {item.marketName}
                                    </p>
                                    <p>{item.content}</p>
                                  </li>
                                ))
                                : null}
                            </ul>
                          </div>
                        );
                      }}
                    </Downshift>
                  </div>
                  <Tabs className="d-flex flex-column h-100 mt-2">
                    <TabList className="mb-2">
                      <Tab>{t("thongTinTraiPhieu")}</Tab>
                      <Tab>{t("lichSuGia")}</Tab>
                    </TabList>
                    <TabPanel style={{ flex: 1 }}>
                      {isMobile ? (
                        <AutoSizer>
                          {({ height, width }) => {
                            return (
                              <div style={{ height: height, width: width }}>
                                <div className="scroll-styled"></div>
                              </div>
                            );
                          }}
                        </AutoSizer>
                      ) : (
                        
                        <div className="detail-bond">
                          <div className="detail-bond-flex-1 box-detail-bond">
                            <div className="title">{t("chiTietMaTraiPhieu")}</div>
                            <div className="body">
                              <div className="body-row">
                                <div className="body-row-label">{t("toChucPhatHanh")}</div>
                                <div className="body-row-value">{stockDetails?.stockInfo?.issuer ?? EMPTY_VALUE}</div>
                              </div>
                              <div className="body-row">
                                <div className="body-row-label">{t("menhGia")}</div>
                                <div className="body-row-value">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.parvalue) ?? EMPTY_VALUE} VNĐ</div>
                              </div>
                              <div className="body-row">
                                <div className="body-row-label">{t("khoiLuongPhatHanh")}</div>
                                <div className="body-row-value">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.totalListingQtty) ?? EMPTY_VALUE}</div>
                              </div>
                              <div className="body-row">
                                <div className="body-row-label">{t("loaiTraiPhieu")}</div>
                                <div className="body-row-value">
                                  {
                                    `${ListBondFeature.First[stockDetails?.stockInfo?.bond_Characteristics?.split(";")[0]] ?? EMPTY_VALUE},
                                    ${ListBondFeature.Second[stockDetails?.stockInfo?.bond_Characteristics?.split(";")[1]] ?? EMPTY_VALUE},
                                    ${ListBondFeature.Third[stockDetails?.stockInfo?.bond_Characteristics?.split(";")[2]] ?? EMPTY_VALUE},
                                    ${ListBondFeature.Four[stockDetails?.stockInfo?.bond_Characteristics?.split(";")[3]] ?? EMPTY_VALUE}`
                                  }
                                </div>
                              </div>

                              <div className="body-row">
                                <div className="body-row-label">{t("taiSanDamBao")}</div>
                                <div className="body-row-value">{stockDetails?.stockInfo?.tsdb === "Y" ? t("co") : t("khong")}</div>
                              </div>
                              <div className="body-row">
                                <div className="body-row-label">{t("ngayPhatHanh")}</div>
                                <div className="body-row-value">{formataDate_DDMMYYYY(stockDetails?.stockInfo?.issueDate) ?? EMPTY_VALUE}</div>
                              </div>
                              <div className="body-row">
                                <div className="body-row-label">{t("ngayDaoHan")}</div>
                                <div className="body-row-value">{formataDate_DDMMYYYY(stockDetails?.stockInfo?.maturitDate) ?? EMPTY_VALUE}</div>
                              </div>    
                              <div className="body-row">
                                <div className="body-row-label">{t("laiSuatBanDau")}</div>
                                <div className="body-row-value">{stockDetails?.stockInfo?.interesT_RATE ?? EMPTY_VALUE}</div>
                              </div>                          
                              <div className="body-row">
                                <div className="body-row-label">{t("loaiLaiSuat")}</div>
                                <div className="body-row-value">{lstInterestrateType[stockDetails?.stockInfo?.interesT_TYPE] ?? EMPTY_VALUE}</div>
                              </div>
                              <div className="body-row">
                                <div className="body-row-label">{t("phuongThucTraLai")}</div>
                                <div className="body-row-value">{lstInterestPaymentType[stockDetails?.stockInfo?.interesT_PAYMENT_TYPE] ?? EMPTY_VALUE}</div>
                              </div>
                            </div>
                            <div></div>
                          </div>
                          <div className="detail-bond-flex-1">
                            <div className="box-detail-bond">
                              <div className="title">{t("dangChaoThiTruong")}</div>
                              <div className="bodyflex">
                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("giaChaoMuaCaoNhat")}</div>
                                  <div className={clsx("bodyflex-item-value clr-up")}>{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_BestBidPrice) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("giaChaoBanThapNhat")}</div>
                                  <div className="bodyflex-item-value clr-down">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_BestOfferPrice) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("klTaiGiaChaoMuaCaoNhat")}</div>
                                  <div className="bodyflex-item-value">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_BestBidQtty) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("klTaiGiaChaoBanThapNhat")}</div>
                                  <div className="bodyflex-item-value">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_BestOfferQtty) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("tongKLChaoMua")}</div>
                                  <div className="bodyflex-item-value">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_TotalBidQtty) ?? EMPTY_VALUE}</div>
                                </div>
                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("tongKLChaoBan")}</div>
                                  <div className="bodyflex-item-value">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_TotalOfferQtty) ?? EMPTY_VALUE}</div>
                                </div>
                              </div>
                            </div>
                            <div className="box-detail-bond box-right">
                              <div className="title">{t("daKhopGiaoDich")}</div>
                              <div className="bodyflex">
                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("giaTHGanNhat")}</div>
                                  <div className={clsx("bodyflex-item-value", matchPriceColor)}>{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_MatchPrice) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("klTaiGiaTHGanNhat")}</div>
                                  <div className={clsx("bodyflex-item-value", matchPriceColor)}>{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_MatchQtty) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("giaThCaoNhat")}</div>
                                  <div className={clsx("bodyflex-item-value", maxPriceColor)}>{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_MaxPrice) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("klTaiGiaTHCaoNhat")}</div>
                                  <div className={clsx("bodyflex-item-value", maxPriceColor)}>{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_MaxQtty) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("giaTHThapNhat")}</div>
                                  <div className={clsx("bodyflex-item-value", minPriceColor)}>{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_MinPrice) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("klTaiGiaTHThapNhat")}</div>
                                  <div className={clsx("bodyflex-item-value", minPriceColor)}>{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_MinQtty) ?? EMPTY_VALUE}</div>
                                </div>


                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("tongGTGD")}</div>
                                  <div className="bodyflex-item-value">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_TotalTradedQtty) ?? EMPTY_VALUE}</div>
                                </div>

                                <div className="bodyflex-item">
                                  <div className="bodyflex-item-label">{t("tongKLGD")}</div>
                                  <div className="bodyflex-item-value">{formatQttyFull_emptyIsZezo(stockDetails?.stockInfo?.pT_TotalTradedValue) ?? EMPTY_VALUE}</div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </TabPanel>
                    <TabPanel style={{ flex: 1 }}>
                      <div className="search-box-tprl">
                        <Form form={formSearch} className="search-box-tprl--form">
                          <Form.Item name={"TradingDateFrom"} label={t("tuNgay")}>
                            <DatePicker size="small" format={globalConst.ANT.LOCALE.dateFormat} placeholder="dd/MM/yyyy" />
                          </Form.Item>
                          <Form.Item name={"TradingDateTo"} label={t("denNgay")}>
                            <DatePicker size="small" format={globalConst.ANT.LOCALE.dateFormat} placeholder="dd/MM/yyyy" />
                          </Form.Item>
                        </Form>
                        <Button onClick={() => searchStockDetail(true)}>
                          <i className="fas fa-search"></i>
                        </Button>
                      </div>
                      <div>
                        <table className="mr-bottom_15 tb-popup-tprl table-scroll">
                          <thead className="text-center">
                            <tr>
                              <th width="8%">{t("ngay")}</th>
                              {/* <th> {t("giaCoKLGDNhieuNhat")}</th> */}
                              <th>{t("giaChaoMuaCaoNhat")}</th>
                              {/* <th>{t("tongKLTaiGiaChaoMuaCaoNhat")}</th> */}
                              <th>{t("giaChaoBanThapNhat")}</th>
                              <th>{t("tongKLTaiGiaChaoBanThapNhat")}</th>
                              <th>{t("giaThucHienCaoNhat")}</th>
                              <th>{t("tongKLTaiGiaTHCaoNhat")}</th>
                              <th>{t("giaThucHienThapNhat")}</th>
                              <th>{t("tongKLTaiGiaTHTHapNhat")}</th>
                              <th>{t("tongKLGD")}</th>
                              <th>{t("tongGTGD")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {stockHists &&
                              stockHists?.stockHis &&
                              stockHists.stockHis.map(function (st, index, array) {
                                return (
                                  <tr key={index}>
                                    <td width="8%">{formataDate_DDMMYYYY(st.tradingDate)}</td>
                                    {/* <td className="text-right">{formatNumber(st.pt_MatchPriceByLargestQtty)}</td> */}
                                    <td className="text-right">{formatNumber(st.pt_BestBidPrice)}</td>
                                    {/* <td className="text-right">{formatNumber(st.totalValueTraded)}</td> */}
                                    <td className="text-right">{formatNumber(st.pt_BestOfferPrice)}</td>
                                    <td className="text-right">{formatNumber(st.pt_MinQtty)}</td>
                                    <td className="text-right">{formatNumber(st.pt_MaxPrice)}</td>
                                    <td className="text-right">{formatNumber(st.pt_MaxQtty)}</td>
                                    <td className="text-right">{formatNumber(st.pt_MinPrice)}</td>
                                    <td className="text-right">{formatNumber(st.pt_MinQtty)}</td>
                                    <td className="text-right">{formatNumber(st.pt_TotalTradedQtty)}</td>
                                    <td className="text-right">{formatNumber(st.pt_TotalTradedValue)}</td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </Draggable>
    </div>
  ) : (
    <></>
  );
}
